import { Customers } from '../../entity.types';

const typologiesConstant = {
  PER: 'Personne physique',
  PUB: 'Institution publique',
  SOC: 'Entreprise ou association',
  OTHER: 'Autre',
};
const enterprisesSizesConstant = {
  TPE: 'Moins de 10 salariés',
  PE: 'Entre 10 et 50 salariés',
  ME: 'Entre 50 et 500 salariés',
  GE: 'Entre 500 et 1000 salariés',
  TGE: 'Plus de 1000 salariés',
  OTHER: 'Autre',
};

export function cleanObject(obj: {
  [s: string]: number;
}): Array<[string, number]> {
  const entries: Array<[string, number]> = Object.keys(obj).map((key) => [
    key,
    obj[key],
  ]);
  return entries
    .filter((entry) => entry[1] > 0)
    .sort((entry1, entry2) => entry2[1] - entry1[1]);
}

function filterCustomers(
  data: Customers['typologies'],
  constant: { [s: string]: string },
) {
  const dictionaryResult: { [s: string]: number } = {};
  Object.keys(data)
    .map((dataKey) => [dataKey, data[dataKey]] as [string, number])
    .filter((dataEntry) => dataEntry[1] > 0)
    .forEach((dataEntry) => {
      Object.keys(constant)
        .map((constKey) => [constKey, constant[constKey]])
        .filter((constEntry) => constEntry[0] === dataEntry[0])
        .forEach((constEntry) => {
          dictionaryResult[constEntry[1]] = dataEntry[1];
        });
    });
  return dictionaryResult;
}

export function getTypologiesFormatted(typologies: Customers['typologies']) {
  const result = filterCustomers(typologies, typologiesConstant);
  if (Object.keys(result).length === 0) {
    return null;
  }
  return result;
}

export function cleanResults(customers: Customers) {
  let enterpriseSectors = null;
  if (
    customers.enterprisesSectors &&
    Object.keys(customers.enterprisesSectors)
      // instead of Object.values to make Flow work
      .map((key) => customers.enterprisesSectors[key])
      .some((value) => value > 0)
  ) {
    enterpriseSectors = customers.enterprisesSectors;
  }

  let typologies = getTypologiesFormatted(customers.typologies);

  let enterpriseSizes: {
    [s: string]: number;
  } | null = filterCustomers(
    customers.enterprisesSizes,
    enterprisesSizesConstant,
  );
  if (Object.keys(enterpriseSizes).length === 0) {
    enterpriseSizes = null;
  }
  if (typologies != null && Object.keys(typologies).length === 0) {
    typologies = null;
  }

  return {
    typologies,
    enterpriseSizes,
    enterpriseSectors,
  };
}
